import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Badge, Button, Card, Modal, Tooltip} from 'antd';
import {AiOutlineDownload, AiOutlineUser} from "react-icons/ai";
import {SiGooglecalendar} from "react-icons/si";
import {IoMegaphoneOutline} from "react-icons/io5";
import {NavLink} from 'react-router-dom';

import classes from './ScheduleTargetDetailsCard.module.scss'

import {getScheduleDownload} from '../../../../store/actions';

import UnderlinedLink from '../../../UI/UnderlinedLink/UnderlinedLink';
import GoogleCalendarModal from '../../GoogleCalendarModal/GoogleCalendarModal';
import AnnouncementsModal from '../../Announcement/AnnouncementsModal/AnnouncementsModal';
import Avatar from "antd/es/avatar/avatar";
import {
    highlightBugReportButton,
    unhighlightBugReportButton
} from "../../../BugReport/BugReportButton/BugRepportButtonUtil";
import {ViewOption} from "../ScheduleView";
import {formatFio, formatFioWithInitials} from "../../../../services/generalService";


const ScheduleTargetDetailsCard = ({ scheduleType, scheduleTarget, viewMode = ViewOption.List }) => {
    const dispatch = useDispatch()

    const [showGoogleCalendarModal, setShowGoogleCalendarModal] = useState(false)
    const [showAnnouncementsModal, setShowAnnouncementsModal] = useState(false)

    const getMainInformation = () => {
        if (scheduleType === 1) {
            return (<div>
                <div className='ScheduleTargetDetailsCard_title_color'>
                    {scheduleTarget.name}
                </div>
                <div className='ScheduleTargetDetailsCard_subtitle_color'>
                    <Tooltip placement="top" title={`${scheduleTarget.facultyName}, ${scheduleTarget.specialityName}`}>
                        <span style={{cursor: 'default'}}>
                            {`${scheduleTarget.facultyAbbrev}, ${scheduleTarget.specialityAbbrev}`}
                        </span>
                    </Tooltip>
                </div>
            </div>);
        }
        if (scheduleType === 2) {
            return (<React.Fragment>
                <div>
                    <NavLink exact to={`/employees/${scheduleTarget.urlId}`}>
                        <Avatar
                            alt="photo"
                            size={90}
                            src={scheduleTarget.photoLink}
                            icon={<AiOutlineUser style={{ position: 'relative', top: '-5px' }} />} />
                    </NavLink>
                </div>
                <div>
                    <div className={classes.employeeName}>
                        <UnderlinedLink
                            href={`/employees/${scheduleTarget.urlId}`}
                            text={formatFio(scheduleTarget)}/>
                    </div>
                    <div>
                        {`${(scheduleTarget.degree ?? '')}${(scheduleTarget.degree && scheduleTarget.rank) ? `, ${scheduleTarget.rank}` : ''}`}
                    </div>
                </div>
            </React.Fragment>);
        }
        return null;
    }

    const getInformationContainerClass = () => {
        return viewMode === ViewOption.List ? classes.listView : classes.tableView;
    }

    return (
        <div>
            <Card className={`${classes.container} ScheduleTargetDetailsCard_container_color`}
                  bodyStyle={{ padding: '12px' }}>

                <div className={`${classes.informationContainer} ${getInformationContainerClass()}`}>
                    {getMainInformation()}
                    <div className={classes.semesterPeriod}>
                        {(scheduleTarget.startDate && scheduleTarget.endDate) &&
                        <div>
                            <div>Начало занятий: <b>{scheduleTarget.startDate}</b></div>
                            <div>Конец занятий: <b>{scheduleTarget.endDate}</b></div>
                        </div>}
                        {(scheduleTarget.startExamsDate && scheduleTarget.endExamsDate) &&
                        <div>
                            <div>Начало сессии: <b>{scheduleTarget.startExamsDate}</b></div>
                            <div>Конец сессии: <b>{scheduleTarget.endExamsDate}</b></div>
                        </div>}
                    </div>

                    <div className={classes.controlsContainer}>
                        <Tooltip placement="top" title="Объявления">
                            {scheduleTarget.announcements.length === 0
                                ? <button aria-label="show announcements"
                                          onClick={() => {
                                              setShowAnnouncementsModal(true)
                                              highlightBugReportButton()
                                          }}>
                                    <IoMegaphoneOutline size={25}/></button>
                                : <Badge count={scheduleTarget.announcements.length}
                                         offset={[-5, 5]}
                                         onClick={() => {
                                             setShowAnnouncementsModal(true)
                                             highlightBugReportButton()
                                         }}>
                                    <button aria-label="show announcements">
                                        <IoMegaphoneOutline size={25}/>
                                    </button>
                                </Badge>}
                        </Tooltip>

                        <Tooltip placement="top" title="Импорт Google календаря">
                            <button aria-label="google calendar import"
                                    onClick={() => {
                                        setShowGoogleCalendarModal(true)
                                        highlightBugReportButton()
                                    }}>
                                <SiGooglecalendar size={22} /></button>
                        </Tooltip>

                        {(scheduleType === 1) && <Tooltip placement="top" title="Скачать расписание Excel">
                            <button aria-label="download schedule .xls"
                                    onClick={() => dispatch(getScheduleDownload(scheduleTarget.name,
                                        '/api/v1/schedule/report?student-group-name=',
                                        `Расписание группы ${scheduleTarget.name}`,
                                        'e'))}>
                                <AiOutlineDownload size={25} /></button>
                        </Tooltip>}

                        {(scheduleType === 2) && <Tooltip placement="top" title="Скачать расписание Excel">
                            <button aria-label="download schedule .xls"
                                    onClick={() => dispatch(getScheduleDownload(scheduleTarget.id,
                                        '/api/v1/employees/schedule/report?employeeId=',
                                        `Расписание ${formatFioWithInitials(scheduleTarget)}`,
                                        'e'))}>
                                <AiOutlineDownload size={25}/>
                            </button>
                        </Tooltip>}
                    </div>
                </div>
            </Card>

            <Modal
                width={1000}
                visible={showAnnouncementsModal}
                title={(
                    <span className={classes.modalHeader}>
                        {
                            ((scheduleType === 1) && `Объявления группы ${scheduleTarget.name}`) ||
                            ((scheduleType === 2) && `Объявления ${formatFioWithInitials(scheduleTarget)}`)
                        }
                    </span>
                )}
                onCancel={() => {
                    setShowAnnouncementsModal(false)
                    unhighlightBugReportButton()
                }}
                footer={null}>
                <AnnouncementsModal scheduleType={scheduleType}
                                    announcements={scheduleTarget.announcements}
                                    loadingAnnouncements={scheduleTarget.loadingAnnouncements} />
            </Modal>

            <Modal
                visible={showGoogleCalendarModal}
                title={(
                    <span className={classes.modalHeader}>
                        Импорт Google календаря
                    </span>
                )}
                onCancel={() => {
                    setShowGoogleCalendarModal(false)
                    unhighlightBugReportButton()
                }}
                footer={[
                    <Button key="back" onClick={() => {
                        setShowGoogleCalendarModal(false)
                        unhighlightBugReportButton()
                    }}>
                        Отмена
                    </Button>
                ]}>
                <GoogleCalendarModal
                    target={
                        ((scheduleType === 1) && scheduleTarget.name) ||
                        ((scheduleType === 2) && `${formatFioWithInitials(scheduleTarget)}`)
                    }
                    calendarId={scheduleTarget.calendarId} />
            </Modal>
        </div>
    )
}

export default ScheduleTargetDetailsCard;
